export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-cell/index.js